import { render, staticRenderFns } from "./TopServiceSteps.vue?vue&type=template&id=940b51d2&scoped=true"
import script from "./TopServiceSteps.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopServiceSteps.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TopServiceSteps.vue?vue&type=style&index=0&id=940b51d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940b51d2",
  null
  
)

export default component.exports